var _path, _path2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSendBtn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.7383 8.26048L2.69036 0.28883C1.71405 -0.195624 0.806155 -0.0548512 0.321422 0.592706C0.079056 0.915999 -0.151583 1.49657 0.128898 2.42761L1.93883 8.41582C2.19292 9.25754 2.19292 10.7371 1.93883 11.5788L0.128898 17.5671C-0.151583 18.4981 0.0780788 19.0796 0.320445 19.4029C0.609721 19.7874 1.05341 20 1.56941 20C1.9183 20 2.29553 19.901 2.68938 19.7058L18.7383 11.7342C19.5397 11.3361 20 10.7022 20 9.99733C20 9.29249 19.5407 8.65853 18.7383 8.26048ZM2.08933 17.8331L3.8113 12.1361C3.91489 11.7934 3.98526 11.3915 4.03021 10.9682H7.43498C7.97542 10.9682 8.41226 10.5342 8.41226 9.99733C8.41226 9.46045 7.97542 9.02648 7.43498 9.02648H4.03021C3.98526 8.60319 3.91587 8.20126 3.8113 7.85855L2.08933 2.1616L17.8646 9.99733L2.08933 17.8331Z",
    fill: "url(#paint0_linear_94_883)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7383 8.26048L2.69036 0.28883C1.71405 -0.195624 0.806155 -0.0548512 0.321422 0.592706C0.079056 0.915999 -0.151583 1.49657 0.128898 2.42761L1.93883 8.41582C2.19292 9.25754 2.19292 10.7371 1.93883 11.5788L0.128898 17.5671C-0.151583 18.4981 0.0780788 19.0796 0.320445 19.4029C0.609721 19.7874 1.05341 20 1.56941 20C1.9183 20 2.29553 19.901 2.68938 19.7058L18.7383 11.7342C19.5397 11.3361 20 10.7022 20 9.99733C20 9.29249 19.5407 8.65853 18.7383 8.26048ZM2.08933 17.8331L3.8113 12.1361C3.91489 11.7934 3.98526 11.3915 4.03021 10.9682H7.43498C7.97542 10.9682 8.41226 10.5342 8.41226 9.99733C8.41226 9.46045 7.97542 9.02648 7.43498 9.02648H4.03021C3.98526 8.60319 3.91587 8.20126 3.8113 7.85855L2.08933 2.1616L17.8646 9.99733L2.08933 17.8331Z",
    fill: "#DADCE0"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_94_883",
    x1: 0,
    y1: 10,
    x2: 20,
    y2: 10,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4ADEDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1AA7EC"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendBtn);
export default __webpack_public_path__ + "static/media/send_btn.3da014f347f1a9efec11e080ee74ca61.svg";
export { ForwardRef as ReactComponent };